export default __webpack_public_path__ + "static/media/search.0a71c207.svg";